<app-page-header></app-page-header>
<app-breadcromb pageName="Personal Information"></app-breadcromb>
<!-- Candidate Dashboard Area Start -->
<section class="candidate-dashboard-area section_70">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-12 dashboard-left-border">
                <div class="dashboard-left">
                    <app-client-dashboard-sidebar></app-client-dashboard-sidebar>
                </div>
            </div>
            <div class="col-lg-9 col-md-12">
                <div class="dashboard-right">
                    <div class="candidate-profile">
                        <div class="candidate-single-profile-info">
                            <form #userForm="ngForm" (ngSubmit)="onSubmit(userForm.value)">
                                <div class="resume-box">
                                    <h3>My Personal Information</h3>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">First Name:</label><span class="ng-star-inserted"> *</span>
                                                <input required #fname="ngModel" ngModel type="text" maxlength="254" name="firstName">
                                                <span *ngIf="fname.invalid && fname.touched" class="error" style="color: red;">First Name is required</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Mid Name:</label>
                                                <input ngModel type="text" maxlength="254" name="midName">
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Last Name:</label><span class="ng-star-inserted"> *</span>
                                                <input required #lname="ngModel" ngModel type="text" maxlength="254" name="lastName">
                                                <span *ngIf="lname.invalid && lname.touched" class="error" style="color: red;">Last Name is required</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top: 3%;">
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Date of Birth:</label><span class="ng-star-inserted"> *</span>
                                                <input max="{{todayDate|date:'yyyy-MM-dd'}}" required #dob="ngModel" ngModel type="date" name="dob">
                                                <span *ngIf="dob.invalid && dob.touched" class="error" style="color: red;">Date of birth is required</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Id Number:</label><span class="ng-star-inserted"> *</span>
                                                <input required #idn="ngModel" ngModel type="text" maxlength="254" name="idNumber">
                                                <span *ngIf="idn.invalid && idn.touched" class="error" style="color: red;">ID number is required</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Languages:</label><span class="ng-star-inserted"> *</span>
                                                <input required #lang="ngModel" ngModel type="text" maxlength="254" name="languages">
                                                <span *ngIf="lang.invalid && lang.touched" class="error" style="color: red;">Languages are required</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top: 3%;">
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label>Gender:</label><span class="ng-star-inserted"> *</span>
                                                <select required #gender="ngModel" ngModel name="gender">
                                <option>Male</option>
                                <option>Female</option>
                             </select>
                                                <span *ngIf="gender.invalid && gender.touched" class="error" style="color: red;">Gender is required</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Marital Status:</label><span class="ng-star-inserted"> *</span>
                                                <input required #mats="ngModel" ngModel type="text" maxlength="254" name="maritalStatus">
                                                <span *ngIf="mats.invalid && mats.touched" class="error" style="color: red;">Marital Status is required</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Religion:</label><span class="ng-star-inserted"> *</span>
                                                <input ngModel type="text" maxlength="254" required #rel="ngModel" name="religion">
                                                <span *ngIf="rel.invalid && rel.touched" class="error" style="color: red;">Religion is required</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top: 3%;">
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Nationality:</label><span class="ng-star-inserted"> *</span>
                                                <input type="text" maxlength="254" required #nat="ngModel" ngModel name="nationality">
                                                <span *ngIf="nat.invalid && nat.touched" class="error" style="color: red;">Nationality is required</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Citizenship:</label><span class="ng-star-inserted"> *</span>
                                                <input type="text" maxlength="254" required #citizen="ngModel" ngModel name="citizen">
                                                <span *ngIf="citizen.invalid && citizen.touched" class="error" style="color: red;">Citizenship is required</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Race:</label><span class="ng-star-inserted"> *</span>
                                                <input type="text" maxlength="254" required #race="ngModel" ngModel name="race">
                                                <span *ngIf="race.invalid && race.touched" class="error" style="color: red;">Race is required</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top: 3%;">
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Cell:</label><span class="ng-star-inserted"> *</span>
                                                <input required #cell="ngModel" ngModel type="text" maxlength="254" name="cellNumber">
                                                <span *ngIf="cell.invalid && cell.touched" class="error" style="color: red;">Cell is required</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Tel:</label>
                                                <input #tel="ngModel" ngModel type="text" maxlength="254" name="landNumber">
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Email:</label><span class="ng-star-inserted"> *</span>
                                                <input pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,6}" required #mail="ngModel" ngModel type="email" name="email">
                                                <span *ngIf="mail.invalid && mail.touched" class="error" style="color: red;">Email is required</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top: 3%;">
                                        <div class="col-md-4">
                                            <div class="single-input">
                                                <label for="name">Address:</label><span class="ng-star-inserted"> *</span>
                                                <textarea required #addr="ngModel" ngModel name="address"></textarea>
                                                <span *ngIf="addr.invalid && addr.touched" class="error" style="color: red;">Address is required</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4"></div>
                                        <div class="col-md-4"></div>
                                    </div>
                                </div>
                                <div class="submit-resume">
                                    <!-- <button class="btn btn-success" >Save</button> -->
                                    <button [disabled]="userForm.invalid" class="btn btn-success">Save</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Candidate Dashboard Area End -->